import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";

import { NotificationAction } from "../../store/actions";

import Spacer from "../../components/spacer/spacer";

import NotifiMainInbox from "./notifimaininbox";

import images from "../../assets";

const Notifications = () => {
  const dispatch = useDispatch();

  const { notifications } = useSelector((state) => state?.notifications);

  useEffect(() => {
    const hasUnread = notifications.some(
      (notification) => notification.status === "unread"
    );

    if (hasUnread) {
      setTimeout(() => {
        dispatch(NotificationAction.markAsSeen());
      }, 3000);
    }
  }, []);

  const now = moment();
  const newNotifications = notifications?.filter((item) =>
    moment(item?.createdAt).isAfter(now.clone().subtract(24, "hours"))
  );
  const earlierNotifications = notifications?.filter((item) =>
    moment(item?.createdAt).isBefore(now.clone().subtract(24, "hours"))
  );

  const handleUpdate = () => {
    dispatch(NotificationAction.markAsRead());
  };

  return (
    <div className="notification-area w-full">
      <div className="notify-heading w-full">
        <div className="notifi-heading-text">Notifications</div>
        <div className="flex gap-2 items-center">
          <div
            className="notifi-sub-heading cursor-pointer p-2 border border-secondary rounded-lg"
            onClick={handleUpdate}
          >
            Mark all as read
          </div>
          <Link to={"/settings?tab=notification"}>
            <img
              src={images.notificationSettingsIcon}
              alt="notification settings"
              className="h-[32px] p-0.5 border border-secondary shadow-basePrimary shadow-sm rounded-md"
            />
          </Link>
        </div>
      </div>
      <div className="notifi-separator" />
      {/* {isLoading ? (
        <Loader />
      ) : ( */}
      <div className="notifi-content-area">
        {notifications?.length === 0 && (
          <div className="flex flex-col justify-center items-center p-10 w-full gap-4">
            <img
              src={images.noNotificationIcon}
              alt="no notifications"
              className="h-[160px] lg:h-full"
            />
            <div className="text-basePrimary font-bold text-[24px] lg:text-[32px]">
              No Notifications Yet
            </div>
            <p className="text-[14px] text-center max-w-[500px]">
              You don’t have any notifications yet. Once you start exploring and
              connecting, we’ll keep you updated right here.
            </p>
          </div>
        )}
        {newNotifications?.length > 0 && (
          <>
            <div className="notifi-content-title">New</div>
            {newNotifications.map((item, index) => (
              <NotifiMainInbox
                title={item?.title}
                subText={item?.description}
                time={moment(item?.createdAt).fromNow()}
                pinkColor={item?.status === "unread" ? "new" : null}
                className={
                  item?.status === "unread" || item?.status === "seen"
                    ? "notifi-unread"
                    : "notifi-read"
                }
                route={item?.actionRoute}
                key={index}
                id={item?.id}
              >
                <img
                  className="notifi-profile-img"
                  src={item?.image ?? images.notificationIcon}
                  alt=""
                />
              </NotifiMainInbox>
            ))}
          </>
        )}

        {earlierNotifications?.length > 0 && (
          <>
            <div className="notifi-content-title">Earlier</div>
            {earlierNotifications.map((item, index) => (
              <NotifiMainInbox
                title={item?.title}
                subText={item?.description}
                time={moment(item?.createdAt).fromNow()}
                pinkColor={item?.status === "unread" ? "new" : null}
                className={
                  item?.status === "unread" || item?.status === "seen"
                    ? "notifi-unread"
                    : "notifi-read"
                }
                route={item?.actionRoute}
                key={index}
                id={item?.id}
              >
                <img
                  className="notifi-profile-img"
                  src={item?.image ?? images.notificationIcon}
                  alt=""
                />
              </NotifiMainInbox>
            ))}
          </>
        )}

        <Spacer height="10px" />
      </div>
      {/* )} */}
    </div>
  );
};

export default Notifications;
